import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

function Counter({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15%" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1500;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setVal(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
}

const STATS = [
  { value: 4, suffix: "+", label: "Years of experience", testid: "stat-years" },
  { value: 50, suffix: "+", label: "Clients worked with", testid: "stat-clients" },
  { value: 100, suffix: "+", label: "Projects completed", testid: "stat-projects" },
  { value: 73, suffix: "M+", label: "Combined subscribers on featured clients", testid: "stat-reach" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-band-container"
      className="relative overflow-hidden border-y border-white/5 bg-[#0B0B0F] py-16 lg:py-20"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-64 w-[60rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#8E2DE2]/10 blur-[120px]"
      />
      <div className="wrap relative grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.testid}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, delay: i * 0.09, ease: [0.22, 1, 0.36, 1] }}
            data-testid={s.testid}
            className="text-center lg:border-l lg:border-white/5 lg:first:border-l-0"
          >
            <p className="text-gradient font-display text-6xl font-black leading-none sm:text-7xl">
              <Counter to={s.value} suffix={s.suffix} />
            </p>
            <p className="mono-label mx-auto mt-4 max-w-[16rem] text-[10px] leading-relaxed text-zinc-500">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
